module.exports = __webpack_public_path__ + "img/censo_web.97d97298.jpg";